module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Semibold.2b035b72.woff";